import { render, staticRenderFns } from "./GenericDownloadEvidenceOptions.vue?vue&type=template&id=49ad4585"
import script from "./GenericDownloadEvidenceOptions.vue?vue&type=script&lang=js"
export * from "./GenericDownloadEvidenceOptions.vue?vue&type=script&lang=js"
import style0 from "./GenericDownloadEvidenceOptions.vue?vue&type=style&index=0&id=49ad4585&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports